import React from 'react';

/* The Commit panel: what the runtime writes when it commits — the commit
   doc fields `beginCommit` fills (backend/shared/blocks/handlers.js) and
   the two headers the receiver sees. Fixture values; the field names and
   the policy version are the real ones. `t` is the spine clock; the fields
   land one by one from `at`, the status flips to committed at `at + 1`,
   and a replayed call at `at + 2` is deduped on the idempotency key. */

const FIELDS = [
  ['actor', 'runtime', 0],
  ['capabilityId', 'webhook · erp-post', 0.12],
  ['reviewId', 'rev_8f3c2a · approved by the controller', 0.24],
  ['policyVersion', '2026.10.1', 0.36],
  ['traceId', 'tr_01J9…K4Q7 · message → run → block', 0.48],
  ['idempotencyKey', 'sha256:3b9e…c1d2 (content-keyed)', 0.6],
  ['payloadHash', 'sha256:7a41…9f0e', 0.72],
];

export default function ReceiptCard({ t, at = 16.5 }) {
  const dt = t - at;
  const committed = dt >= 1;
  const replayed = dt >= 2;
  return (
    <div className={`rcpt ${committed ? 'is-committed' : ''}`}>
      <div className="rcpt-head">
        <strong>Commit record</strong>
        <span className={`rcpt-status is-${committed ? 'committed' : dt >= 0 ? 'pending' : 'idle'}`}>
          {committed ? 'committed' : dt >= 0 ? 'pending' : 'waiting on the gate'}
        </span>
      </div>
      <dl className="rcpt-fields">
        {FIELDS.map(([k, v, d]) => (
          <div key={k} className={dt >= d ? 'is-on' : ''}>
            <dt>{k}</dt>
            <dd>{v}</dd>
          </div>
        ))}
      </dl>
      <div className={`rcpt-headers ${committed ? 'is-on' : ''}`}>
        <span>x-nventr-trace-id: tr_01J9…K4Q7</span>
        <span>idempotency-key: 3b9e…c1d2</span>
        <span className="rcpt-200">{'{ ok: true, status: 200 }'}</span>
      </div>
      <div className={`rcpt-replay ${replayed ? 'is-on' : ''}`}>
        <i />
        <span><strong>Retry replayed the call.</strong> Same idempotency key → already committed. The invoice posted once.</span>
      </div>
    </div>
  );
}
